// @flow

import { type DetailedBoard } from 'app/packages/pinterest-flow-types/board';
import { type Viewer } from 'app/common/lib/react/withViewer';

// Does the viewer own the current board?
export default function doesViewerOwnBoard(board: ?DetailedBoard, viewer: Viewer): boolean {
  const boardOwnerId = board && board.owner && board.owner.id;
  return viewer.isAuth && boardOwnerId === viewer.id;
}
